// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"200":"3e7cd607","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"200":"3e8007dc7e747be0f7bb","245":"1c83455bf164611dbb83","894":"5dc02ff291c75a8dabee"}[chunkId] + ".js";
};